import { experimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/experimentalQuery.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { BadStatusError } from '@confluence/network';

interface MacroPlaceholderADFQueryData {
	experimentalMacroPlaceholderADF: {
		json: string;
	};
}

interface MacroPlaceholderADFQueryVariables {
	contentId: string;
	macroDefinition: string;
}

interface MacroPlaceholderADFResponse {
	[key: string]: unknown;
}

export const experimentalMacroPlaceholderADFQuery = async ({
	variables,
}: {
	variables: MacroPlaceholderADFQueryVariables;
}): Promise<{ data: MacroPlaceholderADFQueryData | undefined }> => {
	const result = await experimentalQuery<
		MacroPlaceholderADFQueryData,
		MacroPlaceholderADFQueryVariables,
		MacroPlaceholderADFResponse
	>({
		url: '/wiki/rest/internal/1.0/macro/placeholder',
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify({
			macro: JSON.parse(variables.macroDefinition),
			contentId: variables.contentId,
		}),
		parseResponseOnError: (error) => {
			if (BadStatusError.isBadStatusError(error)) {
				return { __badStatusError: true } as unknown as MacroPlaceholderADFResponse;
			}
			throw error;
		},
		parseResult: (json) => {
			if (json && typeof json === 'object' && '__badStatusError' in json) {
				return {
					experimentalMacroPlaceholderADF: {
						json: '',
					},
				};
			}
			return {
				experimentalMacroPlaceholderADF: {
					json: JSON.stringify(json),
				},
			};
		},
		variables,
	});

	return {
		data: result.data,
	};
};
